"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _core.makeStyles)({
  root: {
    color: _theme.default.palette.primary.light,
    padding: '0 0 0 30px',
    fontSize: _theme.default.typography.pxToRem(10),
    lineHeight: _theme.default.typography.pxToRem(14),
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'pointer',
      textDecoration: 'none'
    }
  }
});
var _default = exports.default = useStyles;